import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType, useCuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { CuriosityValueValue } from '../CuriosityValueCell/CuriosityValueCell';
import { LocationLink } from '~/components/LocationLink/LocationLink';

interface CuriosityValueCellProps<R extends GridValidRowModel = any> {
  value: CuriosityValueValue;
  row: R;
}

interface LocationEntity {
  address: Union.Nullable<string>;
  city: Union.Nullable<string>;
  postalCode: Union.Nullable<string>;
  countryCode: Union.Nullable<string>;
}

export const CuriosityLocationCell = <R extends GridValidRowModel = any>({ value }: CuriosityValueCellProps<R>) => {
  const { ct } = useCuriosityTranslation(CuriosityNamespaceType.LOCATION);
  const entity = ct(value)?.entity as LocationEntity;

  if (!entity) {
    return <>{NULLISH_CELL_VALUE}</>;
  }

  return <LocationLink value={entity} />;
};
